const sort = (a: unknown, b: unknown, type: 'asc' | 'desc') => {
  if (a === b) {
    return 0;
  }

  switch (a != null ? typeof a:typeof b) {
    case 'boolean':
      if (type === 'asc') {
        return (a as unknown as boolean) === true ? 1 : -1;
      }
      return (a as unknown as boolean) !== true ? 1 : -1;
    case 'string':
      if (type === 'asc') {
        return (a || '') < (b || '') ? 1 : -1;
      }
      return (a || '') > (b || '') ? 1 : -1;
    case 'number':
      if (type === 'asc') {
        return (a as unknown as number) - (b as unknown as number);
      }
      return (b as unknown as number) - (a as unknown as number);
    default:
      if(type === 'asc') {
        return a > b ? 1:-1;
      }
      return a < b ? 1:-1;
  }
};

export default sort;